import { render, staticRenderFns } from "./LG.vue?vue&type=template&id=6d411b88&scoped=true"
import script from "./LG.vue?vue&type=script&lang=js"
export * from "./LG.vue?vue&type=script&lang=js"
import style0 from "./LG.vue?vue&type=style&index=0&id=6d411b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d411b88",
  null
  
)

export default component.exports